import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("p", null, [
    _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
    _createVNode(_component_router_link, { to: _ctx.to }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.textLink), 1)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}